export const enum EActionType {
  STOP = "Stop",
  PLAY = "Play",
  PAUSE = "Pause",
  RESTARTED = "Restarted",
  CLICK = "Click",
  COMPLETED = "Completed",
  LIKE = "Like",
  DISLIKE = "Dislike",
}

export enum EInteractionType {
  INTERACT_WITH_ASSET = "InteractWithAsset",
  ACCESS_TO_CHANNEL = "AccessToChannel",
}

export interface IEventLog {
  sessionId: string;
  channelPath: string;
  channelName: string;
  assetName: string;
  interactionType: EInteractionType;
  action?: EActionType;
  time: Date;
  communityConfigurationId: number;
  hostName: string;
}

export type TChannelEventLogPayload = Pick<
  IEventLog,
  "sessionId" | "channelPath" | "hostName"
> & {
  kisokId: number;
  communityId: number;
  communityName: string;
  communityConfigurationName: string;
};

export type TAssetEventLogPayload = Pick<
  IEventLog,
  "sessionId" | "channelPath" | "action" | "hostName"
> & {
  kisokId: number;
  communityId: number;
  assetPath: string;
  secsDuration?: number;
  communityConfigurationName: string;
  communityName: string;
  videoTitle: string;
  videoLength?: number;
};

export type TFeedbackEventLogPayload = Pick<
  IEventLog,
  "sessionId" | "channelPath" | "action" | "hostName"
> & {
  kisokId: number;
  communityId: number;
  assetPath: string;
  communityName: string;
  communityConfigurationName: string;
};
